import { type EntityResponse, responseStatusEnum } from '@/shared/types/api';
import type { FooterContent } from './../types';
import { parse } from 'valibot';
import { schemeFooterContent } from './schemes';
import useRequest from '@/shared/composables/use-request';

class Footer {
	async fetchContent(): EntityResponse<FooterContent> {
		try {
			const response = await useRequest().$get('/other/footer/');

			if (response.status === responseStatusEnum.error) {
				return response;
			}

			return parse(schemeFooterContent, response.data);
		} catch (e) {
			throw new Error('Error fetch footer content');
		}
	}
}

export default new Footer();
